/**
 * @author Gananath Athukorala
 * @version 1.0
 * @since 06/08/2023
 */

import React, { useEffect, useMemo, useState } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import api from "../../services/AuthApi"
import EditAdvancedSettingsModal from "./EditAdvancedSettingsModal"
import { Box, IconButton, Tooltip } from "@mui/material"
import { Edit, Check, Close } from "@mui/icons-material"
import Alerts from "../../errorHandeling/Alerts"
import { FetchErrorHandeling } from "../../errorHandeling/FetchErrorHandeling"

const SystemSettings = () => {
  // data and fetching state
  const [appData, setAppData] = useState([])
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [appRowCount, setAppRowCount] = useState(0)

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  //table state
  const [columnFilters, setColumnFilters] = useState([])
  const [globalFilter, setGlobalFilter] = useState("")
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  //modals state
  const [updateModalOpen, setUpdateModalOpen] = useState(false)
  const [rowData, setRowData] = useState([])
  // Advanced Settings
  let getAppConfig = {
    headers: {},
  }

  const approveTable = () => {
    setIsLoading(true)
    api
      .get(
        "/settings/" +
          pagination.pageIndex +
          "/" +
          pagination.pageSize +
          "/settingId",
        getAppConfig
      )
      .then((res) => {
        setAppData(res.data?.dataList)
        setAppRowCount(res.data?.total)
        setIsLoading(false)

        setErrorMessages([])
        setIserror(false)
      })
      .catch((error) => {
        setIsLoading(false)
        FetchErrorHandeling(error, setIserror, setErrorMessages, setIserrorShow)
      })
    setIsError(false)
  }

  useEffect(() => {
    approveTable()
  }, [pagination.pageIndex, pagination.pageSize])

  // Table Titles
  const Cell = ({ cell }) => {
    return cell.getValue() ? <Check color="success" /> : <Close color="error" />
  }
  const columns = useMemo(
    () => [
      {
        accessorKey: "setting",
        header: "Setting",
      },
      {
        accessorKey: "description",
        header: "Description",
      },
      {
        accessorKey: "value",
        header: "Value",
      },
      {
        accessorKey: "active",
        header: "Active",
        Cell: Cell,
      },
    ],
    [appData]
  )

  return (
    <div>
      <div>
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          iserrorShow={iserrorShow}
        />
      </div>
      <br />
      <MaterialReactTable
        enableColumnVirtualization
        columns={columns}
        data={appData ?? []}
        state={{
          columnFilters,
          globalFilter,
          pagination,
          isLoading,
        }}
        getRowId={(row) => row.phoneNumber}
        initialState={{ showColumnFilters: false }}
        manualPagination
        muiToolbarAlertBannerProps={
          isError
            ? {
                color: "error",
                children: "Error loading data",
              }
            : undefined
        }
        onColumnFiltersChange={setColumnFilters}
        onGlobalFilterChange={setGlobalFilter}
        onPaginationChange={setPagination}
        rowCount={appRowCount}
        muiTablePaginationProps={{
          rowsPerPageOptions: [10],
        }}
        editingMode="modal"
        enableColumnOrdering
        enableGrouping
        enablePinning
        enableRowActions
        enableEditing
        renderRowActions={({ row }) => (
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Tooltip arrow placement="left" title="Edit">
              <IconButton
                onClick={() => {
                  setUpdateModalOpen(true)
                  setRowData(row.original)
                }}
              >
                <Edit />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      />

      <EditAdvancedSettingsModal
        rowData={rowData}
        open={updateModalOpen}
        onClose={() => {
          setUpdateModalOpen(false)
          approveTable()
        }}
      />
    </div>
  )
}

export default SystemSettings
